export default "__VITE_ASSET__DGFsv4FB__"